import {importSwiper} from "./kp-util";

const carousel_blocks = document.querySelectorAll('.block--logo-carousel')

if (carousel_blocks.length > 0) {
    importSwiper().then(({Swiper, Navigation, Autoplay}) => {
        carousel_blocks.forEach(block => {

            const carousel = block.querySelector('.swiper-image-carousel')
            const next = block.querySelector('.swiper-button-next')
            const prev = block.querySelector('.swiper-button-prev')

            new Swiper(carousel, {
                modules: [Navigation, Autoplay],
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                autoplay: true,
                delay: 4000,
                simulateTouch: false,
                navigation: {nextEl: next, prevEl: prev},
                breakpoints: {768: {slidesPerView: 2, spaceBetween: 40,}, 1024: {slidesPerView: 4, spaceBetween: 30}}
            })
        })
    })
}

